export function formDataToJson(formData: FormData): any {
	const data: any = {};
	for(const [key, value] of (formData as any).entries()) {
		data[key] = value;
	}
	return data;
}

export function getFormJsonData(form: HTMLFormElement): any {
	const formData = new FormData(form);
	return formDataToJson(formData);
}
